import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Heading from '../../common/Heading';
import InputBlock from '../../common/InputBlock';
import SelectOption from '../../common/SelectOption';
import OpenNotification from '../../common/CommonButton/OpenNotification';
import UtilService from '../../../services/util';
import clone from 'lodash/clone';

import cloneDeep from 'lodash/cloneDeep';
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';

import { BASE_URL, MIME_TYPES_PROFILE, LOCAL_STORAGE_VAR } from '../../../constants/Common';
import ProfileUpload from '../../common/ProfileUpload';
import IntlMessages from '../../../util/IntlMessages';
import intlTelInput from 'intl-tel-input';
import { commonLogout } from '../../../constants/Common';
import _ from 'lodash';

import {
  GET_COUNTRY_LIST,
  GET_STATE_LIST,
  GET_CITY_LIST,
  FETCH_USER,
  ADMIN_UPDATE_USER,
  UPLOAD_FILE,
} from '../../../constants/apiConstant';
import DefaultUser from '../../common/UserProfileDefault';
import { profileValidator } from '../../Auth/SignupValidator';

class PersonalInformation extends Component {
  state = {
    mobileData: '',
    mobileValid: true,
    whatsAppData: '',
    whatsAppValid: true,
    emailChanged: false,
    countries: [],
    states: [],
    cities: [],
    errors: null,
    data: {},
  };

  componentDidMount() {
    this.getCountries();
    this.setState({ countryData: window.intlTelInputGlobals.getCountryData() }, () => this.fetchUser());
  }

  getCountries = () => {
    const self = this;
    const obj = {
      ...GET_COUNTRY_LIST,
    };
    UtilService.callApi(obj, function (err, data) {
      if (data && data.code === 'OK') {
        self.setState({ countries: data.data });
      }
    });
  };

  getStates = (countryId) => {
    const self = this;
    const obj = {
      ...GET_STATE_LIST,
      request: { country: countryId },
    };
    UtilService.callApi(obj, function (err, data) {
      if (data && data.code === 'OK') {
        self.setState({ states: data.data });
      }
    });
  };

  getCities = (stateId) => {
    const self = this;
    const obj = {
      ...GET_CITY_LIST,
      request: { state: stateId },
    };
    UtilService.callApi(obj, function (err, data) {
      if (data && data.code === 'OK') {
        self.setState({ cities: data.data });
      }
    });
  };

  fetchUser() {
    const self = this;
    const obj = {
      ...FETCH_USER,
    };
    UtilService.callApi(obj, function (err, data) {
      if (err && err.data.code === 'E_BAD_REQUEST') {
        return OpenNotification({
          type: 'error',
          title: err.data.message,
        });
      } else if (data && data.code === 'OK') {
        if (data.data) {
          const datas = data.data;

          if (datas.whatsappCounCode === '') {
            datas.whatsAppIso = 'in';
          } else {
            datas.whatsAppIso = _.find(self.state.countryData, {
              dialCode: datas.whatsappCounCode,
            }).iso2;
          }
          if (datas.countryCode === '') {
            datas.countryCodeIso = 'in';
          } else {
            datas.countryCodeIso = _.find(self.state.countryData, {
              dialCode: datas.countryCode,
            }).iso2;
          }
          self.setState({ data: datas });
        }
        self.getStates(data.data.country);
        self.getCities(data.data.state);
      }
    });
  }

  updateUser() {
    const self = this;
    const reqObj = clone(self.state.data);
    reqObj.name = `${reqObj.firstName} ${reqObj.lastName}`;

    const obj = {
      ...ADMIN_UPDATE_USER,
      request: reqObj,
    };
    // const storageObj = reqObj;
    // storageObj.account = UtilService.getLocalStorageItem(`${LOCAL_STORAGE_VAR}-user`).account;
    // UtilService.setLocalStorageItem(storageObj, `${LOCAL_STORAGE_VAR}-user`);

    // if (self.handleValidation()) {
    const errors = profileValidator({ ...obj.request });
    if (!errors.isValid) {
      self.setState({ errors: errors.errors });
    } else {
      if (self.state.mobileValid) {
        UtilService.callApi(obj, function (err, data) {
          if (err && err.data) {
            if (err.data.code === 'E_USER_NOT_FOUND') {
              return OpenNotification({
                type: 'error',
                title: err.data.message,
              });
            }
            if (err.data.code === 'E_DUPLICATE') {
              return OpenNotification({
                type: 'error',
                title: err.data.message,
              });
            }
          }
          if (data && data.code === 'OK') {
            //self.props.onClose();
            const storageObj = reqObj;
            storageObj.account = UtilService.getLocalStorageItem(`${LOCAL_STORAGE_VAR}-user`).account;
            UtilService.setLocalStorageItem(storageObj, `${LOCAL_STORAGE_VAR}-user`);
            if (self.state.emailChanged) {
              commonLogout();
            }
            self.props.onClose();
            return OpenNotification({
              type: 'success',
              title: 'Personal details are updated successfully.',
            });
            // self.props.onClose()
          }
        });
      }
    }
  }

  uploadDocument = (ee, type) => {
    const e = cloneDeep(ee);
    const self = this;
    // const errors = clone(this.state.errors);
    const formData = clone(this.state.data);

    var blob = e.target.files[0];
    var fileReader = new FileReader();
    fileReader.onloadend = function (ev) {
      var arr = new Uint8Array(ev.target.result).subarray(0, 4);
      var header = '';
      for (var i = 0; i < arr.length; i++) {
        header += arr[i].toString(16);
      }
      if (
        !MIME_TYPES_PROFILE[blob.type] ||
        (MIME_TYPES_PROFILE[blob.type] && !MIME_TYPES_PROFILE[blob.type].includes(header))
      ) {
        return OpenNotification({
          type: 'error',
          title: 'File format is not supported. Please upload .jpg, .jpeg or .png file.',
        });
      } else {
        const data = new FormData();
        data.append('folder', 'user');
        data.append('file', e.target.files[0]);

        const objData = {
          ...UPLOAD_FILE,
          request: data,
        };
        UtilService.callApi(objData, function (err, data) {
          if (err) throw err;
          if (data && data.code === 'OK') {
            // errors[type] = undefined;
            formData[type] = data.data.files[0].absolutePath;
            self.setState({ data: formData });
          }
        });
      }
    };
    fileReader.readAsArrayBuffer(blob);
  };

  handleInputChange = (key, value) => {
    const { data } = this.state;
    let errors = null;
    if (this.state.errors) {
      errors = Object.assign('', this.state.errors);
      delete errors[key];
    }
    if (key === 'email' && data.email !== value.trim()) {
      this.setState({ emailChanged: true });
    }
    data[key] = key === 'email' ? value.trim() : value;

    this.setState({ data: data, errors });
  };

  // handleValidation = () => {
  //   let formData = this.state.data;
  //   let errors = this.state.errors;
  //   let formIsValid = true;
  //   let blankField = [];
  //   let invalidFiels = [];
  //   if (!formData["firstName"]) {
  //     blankField.push("First Name");
  //     formIsValid = false;
  //   }
  //   if (formData["firstName"]) {
  //     if (!formData["firstName"].match(/^[a-zA-Z ]+$/)) {
  //       invalidFiels.push("firstName");
  //       formIsValid = false;
  //       errors["firstName"] = "Please enter valid First Name.";
  //     } else {
  //       errors["firstName"] = undefined;
  //     }
  //   }

  //   if (!formData["address"]) {
  //     blankField.push("Address 1");
  //     formIsValid = false;
  //   }

  //   if (!formData["email"]) {
  //     blankField.push("Email Address");
  //     formIsValid = false;
  //   }
  //   if (formData["email"]) {
  //     if (
  //       formData["email"] &&
  //       !formData["email"].match(/^[a-zA-Z0-9]+[a-zA-Z0-9._]+@[a-zA-Z0-9]+\.[a-zA-Z.]{2,10}$/)
  //     ) {
  //       invalidFiels.push("Email");
  //       formIsValid = false;
  //       errors["email"] = "Please enter valid Email.";
  //     } else {
  //       errors["email"] = undefined;
  //     }
  //   }
  //   if (!formData["mobile"]) {
  //     blankField.push("Mobile No.");
  //     formIsValid = false;
  //   }
  //   if (formData["mobile"] && errors["mobile"]) {
  //     invalidFiels.push("Mobile No.");
  //     formIsValid = false;
  //     errors["mobile"] = errors["mobile"];
  //   }

  //   if (blankField.length > 0) {
  //     let arr = blankField;
  //     let outStr = "";
  //     if (arr.length === 1) {
  //       outStr = arr[0];
  //     } else if (arr.length === 2) {
  //       outStr = arr.join(" and ");
  //     } else if (arr.length > 2) {
  //       outStr = arr.slice(0, -1).join(", ") + " and " + arr.slice(-1);
  //     }
  //     notification.error({
  //       message: "Required Fields",
  //       placement: "bottomLeft",
  //       description: outStr,
  //     });
  //   }
  //   if (invalidFiels.length > 0) {
  //     let arr = invalidFiels;
  //     let outStr = "";
  //     if (arr.length === 1) {
  //       outStr = arr[0];
  //     } else if (arr.length === 2) {
  //       outStr = arr.join(" and ");
  //     } else if (arr.length > 2) {
  //       outStr = arr.slice(0, -1).join(", ") + " and " + arr.slice(-1);
  //     }
  //     notification.error({
  //       message: "Invalid Fields",
  //       placement: "bottomLeft",
  //       description: outStr,
  //     });
  //   }
  //   this.setState({ errors: errors });
  //   return formIsValid;
  // };
  onBlur = (name, val) => {
    const self = this;
    const data = {
      [name]: val,
    };

    const errors = profileValidator(data);
    if (!errors.isValid) {
      self.setState({ errors: errors.errors });
    }
  };

  render() {
    const { countries, data, states, cities, errors } = this.state;
    return (
      <div>
        <div className="profileHead">
          <Heading title={<IntlMessages id="app.PersonalInformation" />} className="popupInnerTitle"></Heading>
          <div className="personalProfileWrapper">
            <div className="editProfileLogo">
              {_.isEmpty(data.profileImage) ? (
                <DefaultUser size="lg-size" />
              ) : (
                <img
                  alt=""
                  src={
                    _.isEmpty(data.profileImage)
                      ? require('../../../assets/img/header/user.jpg')
                      : BASE_URL + '/' + data.profileImage
                  }
                />
              )}
            </div>
            <div className="profileAction">
              <ProfileUpload
                label={<IntlMessages id="app.EditProfile" />}
                accept="jpg, png,jpeg,PNG,JPEG,JPG"
                onChange={(e) => this.uploadDocument(e, 'profileImage')}
              />
              <a onClick={() => this.handleInputChange('profileImage', '')}>
                <IntlMessages id="app.RemoveProfile" />
              </a>
            </div>
          </div>
        </div>
        <div className="profileDetailSpace">
          <IntlMessages id="app.FirstNameLabel">
            {(placeholder) => (
              <InputBlock
                onBlur={(e) => this.onBlur('firstName', e.target.value)}
                hasError={errors !== null && errors['firstName'] ? errors['firstName'] : false}
                required
                onChange={(e) => this.handleInputChange('firstName', e.target.value)}
                placeholder={placeholder}
                value={data.firstName}
                label={
                  <>
                    <IntlMessages id="app.FirstNameLabel" />
                  </>
                }
              />
            )}
          </IntlMessages>

          <IntlMessages id="app.LastNameLabel">
            {(placeholder) => (
              <InputBlock
                onBlur={(e) => this.onBlur('lastName', e.target.value)}
                hasError={errors !== null && errors['lastName'] ? errors['lastName'] : false}
                onChange={(e) => this.handleInputChange('lastName', e.target.value)}
                placeholder={placeholder}
                value={data.lastName}
                label={<IntlMessages id="app.LastNameLabel" />}
              />
            )}
          </IntlMessages>
          <IntlMessages id="app.AddressLabel">
            {(placeholder) => (
              <InputBlock
                onBlur={(e) => this.onBlur('address', e.target.value)}
                hasError={errors !== null && errors['address'] ? errors['address'] : false}
                onChange={(e) => this.handleInputChange('address', e.target.value)}
                placeholder={placeholder}
                value={data.address}
                label={<IntlMessages id="app.AddressLabel" />}
              />
            )}
          </IntlMessages>

          <IntlMessages id="app.EmailLabel">
            {(placeholder) => (
              <InputBlock
                required
                onBlur={(e) => this.onBlur('email', e.target.value)}
                hasError={errors !== null && errors['email'] ? errors['email'] : false}
                onChange={(e) => this.handleInputChange('email', e.target.value)}
                placeholder={placeholder}
                value={data.email}
                label={
                  <>
                    <IntlMessages id="app.EmailLabel" />
                  </>
                }
              />
            )}
          </IntlMessages>
          <SelectOption
            required
            showSearch
            value={data.country}
            selectValue={countries}
            onChange={(value) => {
              const data = clone(this.state.data);
              data['state'] = undefined;
              data['city'] = undefined;

              data['country'] = value;
              this.getStates(value);
              this.setState({ data, cities: [] });
            }}
            hasError={errors !== null && errors['country'] ? errors['country'] : false}
            label={
              <>
                <IntlMessages id="app.CountryLabel" />
              </>
            }
          />
          <SelectOption
            showSearch
            required
            value={data.state}
            selectValue={states}
            onChange={(value) => {
              const data = clone(this.state.data);

              data['state'] = value;
              this.getCities(value);
              this.setState({ data });
            }}
            hasError={errors !== null && errors['state'] ? errors['state'] : false}
            label={
              <>
                <IntlMessages id="app.StateLabel" />
              </>
            }
          />
          <SelectOption
            showSearch
            value={data.city}
            required
            selectValue={cities}
            onChange={(value) => {
              const data = clone(this.state.data);
              data['city'] = value;
              this.setState({ data });
            }}
            hasError={errors !== null && errors['city'] ? errors['city'] : false}
            label={
              <>
                <IntlMessages id="app.CityLabel" />
              </>
            }
          />
          <IntlMessages id="app.ZipCode">
            {(placeholder) => (
              <InputBlock
                onChange={(e) => this.handleInputChange('pinCode', e.target.value)}
                type="number"
                onBlur={(e) => this.onBlur('pinCode', e.target.value)}
                hasError={errors !== null && errors['pinCode'] ? errors['pinCode'] : false}
                required
                placeholder={placeholder}
                value={data.pinCode}
                label={
                  <>
                    <IntlMessages id="app.ZipCode" />
                  </>
                }
              />
            )}
          </IntlMessages>
          {/* <IntlMessages id="app.WhatsAppLabel">
            {(placeholder) => (
              <InputBlock
                onBlur={(e) => this.onBlur("whatsapp", e.target.value)}
                hasError={errors !== null && errors["whatsapp"] ? errors["whatsapp"] : false}
                onChange={(e) => this.handleInputChange("whatsapp", e.target.value)}
                type="number"
                placeholder={placeholder}
                value={data.whatsapp}
                label={<IntlMessages id="app.WhatsAppLabel" />}
              />
            )}
          </IntlMessages> */}
          <div className="from-group inputBlock countryCodeDropdown">
            <label className="CommonLabel">
              <IntlMessages id="app.WhatsAppLabel" />
              {/* <span style={{ color: data.whatsapp ? 'green' : 'red' }}>*</span> */}
            </label>
            <div className="mobileCodeBlock">
              <span className="countryCode">+{data && data.whatsappCounCode ? data.whatsappCounCode : '91'}</span>
              <IntlTelInput
                onPhoneNumberBlur={(status, value, countryData, number, id) => {
                  this.onBlur('whatsapp', value);
                  // if (status) {
                  //   this.setState({ whatsAppValid: true, whatsAppData: '' });
                  // } else {
                  //   this.setState({ whatsAppValid: false, whatsAppData: 'Please enter the valid whatsapp number.' });
                  // }
                }}
                format={false}
                formatOnInit={false}
                onPhoneNumberChange={(valid, number, d) => {
                  const { data } = this.state;
                  let errors = null;
                  if (this.state.errors) {
                    errors = Object.assign('', this.state.errors);
                    delete errors['whatsapp'];
                  }
                  data['whatsapp'] = number ? number : '';

                  this.setState({ data, errors, whatsAppValid: true, whatsAppData: '' });
                }}
                value={data.whatsapp}
                onSelectFlag={(de, dial, fault) => {
                  const { data } = this.state;
                  data['whatsapp'] = '';
                  data['whatsappCounCode'] = `${dial.dialCode}`;
                  let errors = null;
                  if (this.state.errors) {
                    errors = Object.assign('', this.state.errors);
                    delete errors['whatsapp'];
                  }
                  this.setState({ data });
                }}
                preferredCountries={data && data.whatsAppIso ? [data.whatsAppIso] : ['in']}
                containerClassName="intl-tel-input"
                inputClassName="form-control"
                fieldName="whatsapp"
                customPlaceholder={(a, obj) => {
                  return `${obj.name}`;
                }}
                placeholder={false}
              />
            </div>
            {errors !== null && errors.whatsapp ? (
              <span style={{ color: 'red' }}>{errors.whatsapp}</span>
            ) : (
              !this.state.whatsAppValid && <span style={{ color: 'red' }}>{this.state.whatsAppData}</span>
            )}
          </div>
          <div className="from-group inputBlock countryCodeDropdown">
            <label className="CommonLabel">
              <IntlMessages id="app.MobileNoLabel" /> <span style={{ color: data.mobile ? 'green' : 'red' }}>*</span>
            </label>
            <div className="mobileCodeBlock">
              <span className="countryCode">+{data && data.countryCode ? data.countryCode : '91'}</span>
              <IntlTelInput
                onPhoneNumberBlur={(status, value, countryData, number, id) => {
                  this.onBlur('mobile', value);
                  // if (status) {
                  //   this.setState({ mobileValid: true, mobileData: '' });
                  // } else {
                  //   this.setState({ mobileValid: false, mobileData: 'Please enter the valid Phone number.' });
                  // }
                }}
                format={false}
                formatOnInit={false}
                onPhoneNumberChange={(valid, number, d) => {
                  const { data } = this.state;
                  let errors = null;
                  if (this.state.errors) {
                    errors = Object.assign('', this.state.errors);
                    delete errors['mobile'];
                  }

                  data['mobile'] = number ? number : '';

                  this.setState({ data, errors, mobileValid: true, mobileData: '' });
                }}
                value={data.mobile}
                onSelectFlag={(de, dial, fault) => {
                  const { data } = this.state;
                  data['mobile'] = '';
                  data['countryCode'] = `${dial.dialCode}`;

                  let errors = null;
                  if (this.state.errors) {
                    errors = Object.assign('', this.state.errors);
                    delete errors['mobile'];
                  }

                  this.setState({ data });
                }}
                preferredCountries={data && data.countryCodeIso ? [data.countryCodeIso] : ['in']}
                containerClassName="intl-tel-input"
                inputClassName="form-control"
                fieldName="mobile"
                customPlaceholder={(a, obj) => {
                  return `${obj.name}`;
                }}
                placeholder={false}
              />
            </div>

            {errors !== null && errors.mobile ? (
              <span style={{ color: 'red' }}>{errors.mobile}</span>
            ) : (
              !this.state.mobileValid && <span style={{ color: 'red' }}>{this.state.mobileData}</span>
            )}
          </div>

          <IntlMessages id="app.SkypeLabel">
            {(placeholder) => (
              <InputBlock
                onChange={(e) => this.handleInputChange('skype', e.target.value)}
                placeholder={placeholder}
                value={data.skype}
                label={<IntlMessages id="app.SkypeLabel" />}
              />
            )}
          </IntlMessages>
        </div>
        <div className="sideBarPopupButton">
          <a className="commonButton" onClick={() => this.updateUser()}>
            <IntlMessages id="app.my-account.SavePersonalDetail" />
          </a>
          <a
            className="commonButton"
            onClick={() => {
              this.props.onClose();
            }}
          >
            <IntlMessages id="app.Cancel" />
          </a>
        </div>
      </div>
    );
  }
}
export default withRouter(PersonalInformation);
